<template>
  <div class="page-content">
    <div class="head box-card">
      <div class="box-card-head">单据信息</div>
      <div class="head-content">
        <span>原库区：</span>
        <el-select
          style="width: 280px !important;"
          v-model="yaId"
          placeholder="请选择原库区"
          @change="changeCargo"
        >
          <el-option
            v-for="(item, index) in intoConfigSelect"
            :key="index"
            :label="item.yaName"
            :value="item.yaId"
          ></el-option>
        </el-select>
        <span style="margin-left:20px">原货位：</span>
        <el-select
          style="width: 280px !important;"
          v-model="ylId"
          placeholder="请选择原货位"
          @change="changeSupplier"
        >
          <el-option
            v-for="(item,index) in cargoSelect"
            :key="index"
            :label="item.ylCode"
            :value="item.ylId">
          </el-option>
        </el-select>
        <span style="margin-left:20px">供应商名称：</span>
        <el-select
          style="width: 280px !important;"
          v-model="supplier"
          placeholder="请选择供应商"
          @change="changeSupplier"
        >
          <el-option
            v-for="(item, index) in supplierSelect"
            :key="index"
            :label="item.supplierName"
            :value="item.supplierCode"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="body box-card">
      <div class="box-card-head">商品信息</div>
      <el-button
        style="width: 100px;margin-bottom: 10px;"
        type="primary"
        @click="addProduct"
      >添加商品</el-button>
      <el-table
        height="calc(100% - 142px)"
        :data="selProductionsList"
        :row-key="getRowsKey"
        border
        class="addPutawayList"
        style="width: 100%"
      >
        <!-- <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column> -->
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="goodsName" label="商品名称" align="center"></el-table-column>
        <el-table-column prop="goodsAtt" label="商品属性" width="100" align="center"></el-table-column>
        <el-table-column prop="standard" label="规格" width="100" align="center"></el-table-column>
        <el-table-column prop="box" label="箱规（件/箱）" width="120" align="center"></el-table-column>
        <el-table-column
          prop="availableNormalNum"
          :label="'可上架数量\n(正常品)'"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <div>{{scope.row.availableNormalNum}}{{scope.row.minUnit || '件'}}</div>
            <div>({{ Math.floor(scope.row.availableNormalNum / scope.row.box) }}{{scope.row.maxUnit || '箱'}}{{ scope.row.availableNormalNum % scope.row.box }}{{scope.row.minUnit || '件'}})</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="availableBrokenNum"
          :label="'可上架数量\n(破损品)'"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <div>{{scope.row.availableBrokenNum}}{{scope.row.minUnit || '件'}}</div>
            <div>({{ Math.floor(scope.row.availableBrokenNum / scope.row.box) }}{{scope.row.maxUnit || '箱'}}{{ scope.row.availableBrokenNum % scope.row.box }}{{scope.row.minUnit || '件'}})</div>
          </template>
        </el-table-column>
        <el-table-column prop="allNum" :label="'总数量\n(正常品)'" width="100" align="center">
          <template slot-scope="scope">
            <div v-if="(isMdOpen==1) && (scope.row.openStatus == 1)">
              <div>{{scope.row.allNum || 0}}{{scope.row.minUnit || '件'}}</div>
              <div>({{ scope.row.allNum ? Math.floor(scope.row.allNum / scope.row.box) : 0 }}{{scope.row.maxUnit || '箱'}}{{ scope.row.allNum ? scope.row.allNum % scope.row.box : 0 }}{{scope.row.minUnit || '件'}})</div>
            </div>
            <div v-else>
              <el-input
                v-model="scope.row.allNum"
                class="num-input"
                @input="inputAllNum($event, scope.row)"
                @blur="blurAllNum($event, scope.row)"
                oninput="value=value.replace(/[^\d]/g,'')"
              ></el-input>
              <span>{{scope.row.minUnit || '件'}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="brokenAllNum" :label="'总数量\n(破损品)'" width="100" align="center">
          <template slot-scope="scope">
            <div v-if="(isMdOpen==1) && (scope.row.openStatus == 1)">
              <div>{{scope.row.brokenAllNum || 0}}{{scope.row.minUnit || '件'}}</div>
              <div>({{ scope.row.brokenAllNum ? Math.floor(scope.row.brokenAllNum / scope.row.box) : 0 }}{{scope.row.maxUnit || '箱'}}{{ scope.row.brokenAllNum ? scope.row.brokenAllNum % scope.row.box : 0 }}{{scope.row.minUnit || '件'}})</div>
            </div>
            <div v-else>
              <el-input
                v-model="scope.row.brokenAllNum"
                class="num-input"
                @input="inputBrokenAllNum($event, scope.row)"
                @blur="blurBrokenAllNum($event, scope.row)"
                oninput="value=value.replace(/[^\d]/g,'')"
              ></el-input>
              <span>{{scope.row.minUnit || '件'}}</span>
              <!--  -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="goodsCode" label="商品编码" width="140" align="center"></el-table-column>
        <el-table-column prop="barCode" label="商品条码" width="125" align="center"></el-table-column>
        <el-table-column fixed="right" label="操作" width="125" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="(isMdOpen==1) && (scope.row.openStatus == 1)"
              type="text"
              size="mini"
              @click="handleSelProductionDate(scope.row, scope.$index)"
            >选择生产日期</el-button>
            <el-button type="text" size="mini" @click="handleDel(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <div style="color: 888;font-size: 13px;margin-top: 8px;">备注：开启生产日期管理的商品可选择生产日期出库。</div>
        <div style="text-align: center;margin-top: 12px;">
          <el-button style="width: 100px;" size="mini" @click="cancle">取消</el-button>
          <el-button
            style="width: 100px;margin-left: 80px;"
            type="primary"
            size="mini"
            @click="submit"
          >保存</el-button>
        </div>
      </div>
    </div>
    <!-- 选择商品对话框 -->
    <el-dialog
      title="添加商品"
      class="active-add-product-dialog"
      :visible.sync="productOpen"
      width="1000px"
      append-to-body
      :before-close="cancelProduct"
    >
      <div class="fce">
        <el-form
          ref="productQueryForm"
          class="add-project-apply-search-form search-form"
          :model="productQueryParams"
          :inline="true"
          label-width="0px"
          @submit.native.prevent
        >
          <el-form-item label prop="goodsName">
            <el-input
              v-model="productQueryParams.goodsName"
              placeholder="输入商品名称"
              clearable
              size="small"
              class="search-input"
              @keyup.enter.native="handleAddProductQuery"
            />
          </el-form-item>
          <el-form-item label prop="goodsCode">
            <el-input
              v-model="productQueryParams.goodsCode"
              placeholder="输入商品编码"
              clearable
              size="small"
              class="search-input"
              @keyup.enter.native="handleAddProductQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="search-confirm-btn search-btn"
              size="mini"
              @click="handleAddProductQuery"
            >搜索</el-button>
            <el-button
              class="search-cancel-btn search-btn"
              size="mini"
              @click="resetAddProductQuery"
            >重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="product-content">
        <!-- 搜索 E -->
        <el-table
          :data="productList"
          style="width: 100%"
          @selection-change="handleAddProductSelect"
          ref="addProductTable"
          border
          :row-key="getRowsKey"
        >
          <el-table-column
            type="selection"
            :selectable="selectable"
            :reserve-selection="true"
            width="55"
          ></el-table-column>
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column prop="goodsName" label="商品名称" align="center"></el-table-column>
          <el-table-column prop="goodsAtt" label="商品属性" width="100" align="center"></el-table-column>
          <el-table-column prop="standard" label="规格" width="100" align="center"></el-table-column>
          <el-table-column prop="box" label="箱规（件/箱）" width="120" align="center"></el-table-column>
          <el-table-column
            v-if="isMdOpen==1"
            prop="expDays"
            label="保质期(天)"
            width="90"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="availableNormalNum"
            :label="'可上架数量\n(正常品)'"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <div>{{scope.row.availableNormalNum}}{{scope.row.minUnit || '件'}}</div>
              <div>({{ Math.floor(scope.row.availableNormalNum / scope.row.box) }}{{scope.row.maxUnit || '箱'}}{{ scope.row.availableNormalNum % scope.row.box }}{{scope.row.minUnit || '件'}})</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="availableBrokenNum"
            :label="'可上架数量\n(破损品)'"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <div>{{scope.row.availableBrokenNum}}{{scope.row.minUnit || '件'}}</div>
              <div>({{ Math.floor(scope.row.availableBrokenNum / scope.row.box) }}{{scope.row.maxUnit || '箱'}}{{ scope.row.availableBrokenNum % scope.row.box }}{{scope.row.minUnit || '件'}})</div>
            </template>
          </el-table-column>
          <el-table-column prop="goodsCode" label="商品编码" width="140" align="center"></el-table-column>
          <el-table-column prop="barCode" label="商品条码" width="125" align="center"></el-table-column>
          <el-table-column prop="supplierName" label="供应商" width="180" align="center"></el-table-column>
        </el-table>
        <!-- <div class="content-pagination">
          <el-pagination
            :current-page.sync="productQueryParams.page"
            :page-size.sync="productQueryParams.limit"
            layout="sizes, prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="getProductList"
          />
        </div>-->
      </div>
      <span slot="footer" class="dialog-footer">
        <span
          style="display:inline-block;float: left;font-size:14px;color:gray;line-height:35px"
        >备注：只能选择暂存区中的可上架商品(已减去创建了上架单，但未完成的部分)。</span>
        <el-button @click="cancelProduct">取 消</el-button>
        <el-button type="primary" @click="submitProduct">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 选择商品对话框 -->
    <el-dialog title="选择生产日期" :visible.sync="producedDateOpen" width="970px" append-to-body>
      <div
        style="line-height: 23px; color: #555; font-size: 13px; font-weight: 600;padding-left: 10px;"
      >{{productionDateRow && productionDateRow.goodsName}}</div>
      <div class="page-content-table">
        <div class="page-content-head">
          <div class="table-td vertical1">序号</div>
          <!-- <div class="table-td vertical2">商品名称</div> -->
          <div class="table-td vertical3">
            <div style="display: inline-block;width: 150px;text-align: center;">生产日期</div>
            <div style="display: inline-block;width: calc(100% - 150px);"></div>
          </div>
          <div class="table-td vertical4">有效期至</div>
          <div class="table-td vertical5">
            <div>可上架数量</div>
            <div class="table-td-second">(正常品)</div>
          </div>
          <div class="table-td vertical6">
            <div>可上架数量</div>
            <div class="table-td-second">(破损品)</div>
          </div>
          <div class="table-td vertical7">
            <div>数量</div>
            <div class="table-td-second">(正常品)</div>
          </div>
          <div class="table-td vertical8">
            <div>数量</div>
            <div class="table-td-second">(破损品)</div>
          </div>
        </div>
        <el-scrollbar wrap-class="scrollbar-wrapper" class="page-content-body">
          <div class="page-content-body-list">
            <div
              v-for="(citem, cindex) in (productionDateRow && productionDateRow.batchList)"
              :key="cindex"
              class="page-content-body-item"
            >
              <div class="table-td vertical1">
                <span>{{ cindex + 1 }}</span>
              </div>
              <!-- <div class="table-td vertical2 text-one">
                <span v-if="cindex == 0">{{ item.name }}</span>
              </div>-->
              <div class="table-td vertical3">
                <div style="display: inline-block;width: 150px;text-align: center;">
                  <el-select
                    style="width: 140px !important;"
                    v-model="citem.ysdgProductionTime"
                    placeholder="请选择"
                    @change="selDate($event, cindex, productionDateRow.expDays, citem.ysdgProductionTime)"
                  >
                    <el-option
                      v-for="(item, index) in productionDateRow.goodsBatch"
                      :key="index"
                      :label="item.ysdgProductionTime"
                      :value="item.ysdgProductionTime"
                      :disabled="item.disabled"
                    ></el-option>
                  </el-select>
                  <!-- <el-date-picker
                    v-model="citem.ysdgProductionTime"
                    class="date-select"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择"
                    @change="selDate($event, cindex, productionDateRow.expDays)"
                  ></el-date-picker>-->
                </div>
                <div style="display: inline-block;width: calc(100% - 150px);">
                  <span
                    v-if="cindex == 0"
                    style="color: #409eff;cursor:pointer;"
                    @click="handleAddDate"
                  >+日期</span>
                  <el-button
                    style="color: red !important;"
                    v-else
                    type="text"
                    icon="el-icon-delete"
                    @click="handleDelDate(cindex)"
                  ></el-button>
                </div>
              </div>
              <div class="table-td vertical4" :style="citem.isPastDue ? 'color: red;': ''">{{ citem.validUntil }}</div>
              <div class="table-td vertical5">
                <div>{{citem.ysdgAllInventory}}{{productionDateRow.minUnit || '件'}}</div>
                <div
                  class="table-td-second"
                >({{ Math.floor(citem.ysdgAllInventory / productionDateRow.box) }}{{productionDateRow.maxUnit || '箱'}}{{ citem.ysdgAllInventory % productionDateRow.box }}{{productionDateRow.minUnit || '件'}})</div>
              </div>
              <div class="table-td vertical6">
                <div>{{citem.ysdgAllBrokenInventory}}{{productionDateRow.minUnit || '件'}}</div>
                <div
                  class="table-td-second"
                >({{ Math.floor(citem.ysdgAllBrokenInventory / productionDateRow.box) }}{{productionDateRow.maxUnit || '箱'}}{{ citem.ysdgAllBrokenInventory % productionDateRow.box }}{{productionDateRow.minUnit || '件'}})</div>
              </div>
              <div class="table-td vertical7">
                <el-input v-model="citem.ysdgInventory" class="num-input" oninput="value=value.replace(/[^\d]/g,'')" @input="inputProductDateNormalAllNum"></el-input>
                <span>{{productionDateRow.minUnit || '件'}}</span>
              </div>
              <div class="table-td vertical8">
                <el-input v-model="citem.ysdgBrokenInventory" class="num-input" oninput="value=value.replace(/[^\d]/g,'')" @input="inputProductDateBrokenAllNum"></el-input>
                <span>{{productionDateRow.minUnit || '件'}}</span>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div>
        <div style="color: #888;font-size: 13px;margin-top: 10px;text-align: right;"><!-- 备注：开启生产日期管理的商品才需要填生产日期，有效期至红色表示已过期。 -->合计：正常品{{selproductionDateNormalTotal}}件，破损品{{selproductionDateBrokenTotal}}件</div>
        <div style="text-align: center; margin-top: 15px;">
          <el-button style="width: 100px;" size="mini" @click="cancleProductionDateOpen">取消</el-button>
          <el-button
            style="width: 100px;margin-left: 80px;"
            type="primary"
            size="mini"
            @click="submitProductionDateOpen"
          >保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import rollsHomework from '@/store/rollsHomework/index'
import { GETPRODUCTLIST, SAVESHELVESORDER, GETSHELVESDOCUMENTSSUPPLIERSELECT } from '@/store/rollsHomework/types'
// import goodsManage from '@/store/goodsManage/index.js'
// import { SUPPLIERGETLISTS } from '@/store/goodsManage/types.js'
import { parseTime } from '@/utils'
import {CLOSECURRENTTAG} from '@/store/user/types'
// import user from '@/store/user/index'
// import { GETRESERVOIRAREALIST } from '@/store/reservoirAreaManage/types.js'
import reservoirAreaManage from '@/store/reservoirAreaManage/index'
import { SELECTAREALIST, GETHECKED } from '@/store/warehouseTactics/types.js'
import warehouseTactics from '@/store/warehouseTactics/index'

let verifyIndex = 0
let selDateIndex = 0
let _self
export default {
  name: 'addPutawayList',
  data () {
    return {
      warehouseCode: '',
      supplier: '',
      yaId: '',
      ylId: '',
      tempSelProductionsList: [], // 暂时选区
      selProductionsList: [],
      searchSelProductionsList: [], // 搜索保留的选项
      productOpen: false,
      productQueryParams: {
        goodsName: '',
        goodsCode: ''
      },
      total: 0,
      // 选择生产日期
      producedDateOpen: false,
      productionDateIndex: 0, // 选中的商品下标
      productionDateRow: null,
      selproductionDateBrokenTotal: 0,
      selproductionDateNormalTotal: 0,
      isMdOpen: 0
    }
  },
  components: {},
  computed: {
    // 下拉框 - 供应商
    supplierSelect () {
      return rollsHomework.state.supplierSelect
    },
    // 商品列表
    productList () {
      return rollsHomework.state.productList
    },
    productDateMark () {
      return rollsHomework.state.productDateMark
    },
    // 用户信息
    // userInfo () {
    //   return user.state.userinfo
    // },
    reservoirAreaList () {
      return reservoirAreaManage.state.reservoirAreaList.rows
    },
    // 原库区 - 下拉框
    intoConfigSelect () {
      return warehouseTactics.state.intoConfigSelect
    },
    // 原货位 - 下拉框
    cargoSelect () {
      let arr = []
      if (this.yaId) {
        let result = this.intoConfigSelect.find(item => this.yaId === item.yaId)
        if (result.ylList && result.ylList.length > 0) {
          arr = result.ylList
        } else {
          this.$message.error('该库区下未添加货位，请先添加')
        }
      }
      return arr
    }
  },
  watch: {
    // 原货位
    ylId: {
      deep: true,
      handler (val) {
        this.supplier = ''
        this.getSupplierSelect()
      }
    },
    productDateMark: {
      deep: true,
      handler (val) {
        if (val === 1) {
          rollsHomework.state.productDateMark = 0
          this.$store.dispatch('tagsView/setBeforePageName', 'putawayList')
          this.$store.dispatch(CLOSECURRENTTAG, '/rollsHomework/putawayList')
        }
      }
    }
  },
  created () {
    this.warehouseCode = this.$route.params.warehouseCode
  },
  mounted () {
    _self = this
    this.getList()
    this.getCheck(this.warehouseCode)

    // this.getReservoirAreaList()
  },
  methods: {
    getSupplierSelect () {
      let params = {
        ylId: this.ylId,
        warehouseCode: this.warehouseCode
      }
      this.$store.dispatch(GETSHELVESDOCUMENTSSUPPLIERSELECT, params)
    },
    // 获取列表
    // 获取原库区下拉框
    // getReservoirAreaList () {
    //   let params = {
    //     warehouseCode: this.userInfo.warehouseCode
    //   }
    //   this.$store.dispatch(GETRESERVOIRAREALIST, params)
    // },
    // 获取原货位下拉框
    getList () {
      let params = {
        warehouseCode: this.warehouseCode,
        yaNature: '2'
      }
      this.$store.dispatch(SELECTAREALIST, params)
    },
    // 添加商品
    addProduct () {
      if (!this.yaId) {
        return this.$message.warning('请选择原库区！')
      }
      if (!this.ylId) {
        return this.$message.warning('请选择原货位！')
      }
      if (!this.supplier) {
        return this.$message.warning('请选择供应商！')
      }
      this.productOpen = true
      this.changePageCoreRecordData('goodsCode', 'selProductionsList', 'searchSelProductionsList')
      this.getGoodsList()
    },
    // 获取新增商品列表
    getGoodsList () {
      let params = this.productQueryParams
      params.supplierCode = this.supplier
      params.yaId = this.yaId
      params.ylId = this.ylId
      params.warehouseCode = this.warehouseCode
      this.$store.dispatch(GETPRODUCTLIST, params).then((data) => {
        if (this.searchSelProductionsList.length) {
          this.setSelectRow('addProductTable', data, 'searchSelProductionsList', 'goodsCode')
        }
      })

      // if (this.multipleSelection.length !== 0) {
      //   this.$refs.multipleTable.clearSelection()// 未保存的 取消选中状态
      //   this.selectGoodsList.forEach(row => {
      //     this.$refs.multipleTable.toggleRowSelection(row)
      //   })
      // }
    },
    // table设置禁用
    selectable ({ goodsCode }) {
      let checkListIds = this.selProductionsList.map(x => x.goodsCode)
      if (checkListIds.indexOf(goodsCode) > -1) {
        return false
      }
      return true
    },
    // 商品搜索
    handleAddProductQuery () {
      this.changePageCoreRecordData('goodsCode', 'tempSelProductionsList', 'searchSelProductionsList')
      console.log(this.searchSelProductionsList, '测试')
      this.tempSelProductionsList = []
      // this.setSelectRow('addProductTable', data, 'selProductionsList', 'goodsCode')
      this.getGoodsList()
    },
    // 重置商品搜索
    resetAddProductQuery () {
      this.changePageCoreRecordData('goodsCode', 'tempSelProductionsList', 'searchSelProductionsList')
      this.tempSelProductionsList = []
      this.productQueryParams = {
        goodsName: '',
        goodsCode: ''
      }
      this.getGoodsList()
    },
    changeCargo () {
      this.ylId = ''
      this.changeSupplier()
    },
    // 获取商品列表
    changeSupplier () {
      this.selProductionsList = []
    },
    getRowsKey (row) {
      return row.goodsCode
    },
    // 选择商品
    handleAddProductSelect (selection) {
      this.tempSelProductionsList = selection
    },
    submitProduct () {
      this.changePageCoreRecordData('goodsCode', 'tempSelProductionsList', 'searchSelProductionsList')
      this.$set(this, 'selProductionsList', [...this.searchSelProductionsList])
      // this.selProductionsList = [...this.tempSelProductionsList]
      console.log(this.selProductionsList)
      this.$refs.addProductTable.clearSelection()
      this.tempSelProductionsList = []
      this.searchSelProductionsList = []
      this.productQueryParams = {
        goodsName: '',
        goodsCode: ''
      }
      this.productOpen = false
    },
    cancelProduct () {
      this.tempSelProductionsList = []
      this.$refs.addProductTable.clearSelection()
      this.searchSelProductionsList = []
      this.productQueryParams = {
        goodsName: '',
        goodsCode: ''
      }
      this.productOpen = false
    },
    blurAllNum (e, row) {
      if (e.target.value === '') {
        if (row.batchList && row.batchList.length) {
          row.batchList[0].ysdgInventory = 0
        } else {
          row.batchList = [
            {
              ysdgId: undefined, // 批次id
              ysdgProductionTime: '无', // 批次生产日期
              ysdgInventory: 0, // 正常品
              ysdgBrokenInventory: 0 // 破损品
            }
          ]
        }
      }
    },
    blurBrokenAllNum (e, row) {
      if (e.target.value === '') {
        if (row.batchList && row.batchList.length) {
          row.batchList[0].ysdgBrokenInventory = 0
        } else {
          row.batchList = [
            {
              ytgbId: undefined, // 批次id
              ysdgProductionTime: '无', // 批次生产日期
              ysdgInventory: 0, // 正常品
              ysdgBrokenInventory: 0 // 破损品
            }
          ]
        }
      }
    },
    inputAllNum (e, row) {
      this.$forceUpdate()
      if (row.batchList && row.batchList.length) {
        row.batchList[0].ysdgInventory = e
      } else {
        row.batchList = [
          {
            ytgbId: undefined, // 批次id
            ysdgProductionTime: '无', // 批次生产日期
            ysdgInventory: e, // 正常品
            ysdgBrokenInventory: 0 // 破损品
          }
        ]
      }
    },
    inputBrokenAllNum (e, row) {
      this.$forceUpdate()
      if (row.batchList && row.batchList.length) {
        row.batchList[0].ysdgBrokenInventory = e
      } else {
        row.batchList = [
          {
            ytgbId: undefined, // 批次id
            ysdgProductionTime: '无', // 批次生产日期
            ysdgInventory: 0, // 正常品
            ysdgBrokenInventory: e // 破损品
          }
        ]
      }
    },
    submit () {
      let D = [...this.selProductionsList]
      for (let i = 0; i < D.length; i++) {
        D[i].goodsBatch = []
        D[i].goodsBatch = D[i].batchList
      }
      // D.forEach(x => {
      //   x.goodsBatch = D.batchList
      // })
      verifyIndex = 0
      this.coverVerify(D)
    },
    coverVerify (D) {
      if (!this.yaId) {
        return this.$message.warning('请选择原库区！')
      }
      if (!this.ylId) {
        return this.$message.warning('请选择原货位！')
      }
      if (!this.supplier) {
        return this.$message.warning('请选择供应商！')
      }
      if (!D.length) {
        this.$message({
          message: '请选择商品',
          type: 'warning'
        })
        return
      }
      let brokenAllNum = D[verifyIndex].brokenAllNum || '0'
      let allNum = D[verifyIndex].allNum || '0'
      let availableNormalNum = D[verifyIndex].availableNormalNum
      let availableBrokenNum = D[verifyIndex].availableBrokenNum
      // eslint-disable-next-line eqeqeq
      if ((parseInt(brokenAllNum || 0) + parseInt(allNum || 0)) == 0) {
        this.$message({
          message: '商品数量不能为空或为0，请填写' + D[verifyIndex].goodsName + '的商品数量',
          type: 'warning'
        })
        return
      }
      if ((parseInt(availableNormalNum || 0)) < parseInt(allNum || 0)) {
        this.$message({
          message: D[verifyIndex].goodsName + '的正常品，可上架数量不足，请重新选择。',
          type: 'warning'
        })
        return
      }
      if ((parseInt(availableBrokenNum || 0)) < parseInt(brokenAllNum || 0)) {
        this.$message({
          message: D[verifyIndex].goodsName + '的破损品，可上架数量不足，请重新选择。',
          type: 'warning'
        })
        return
      }
      if ((verifyIndex + 1) < D.length) {
        verifyIndex++
        this.coverVerify(D)
      } else {
        let params = {
          ycSupplierCode: this.supplier,
          ycWarehouseCode: this.warehouseCode,
          ysdSourceType: 1,
          goodsVoList: [...D],
          ylId: this.ylId
        }
        this.$store.dispatch(SAVESHELVESORDER, params)
      }
    },
    cancle () {
      rollsHomework.state.productDateMark = 1
    },
    handleSelProductionDate (row, index) {
      this.productionDateIndex = index
      this.selproductionDateBrokenTotal = 0
      this.selproductionDateNormalTotal = 0
      if (!row.batchList || (!row.batchList.length)) {
        row.batchList = [
          {
            ytgbId: '', // 批次id
            ysdgProductionTime: '', // 生产日期
            ysdgInventory: 0, // 批次正常品
            ysdgBrokenInventory: 0, // 批次破损品
            validUntil: '',
            ysdgAllBrokenInventory: 0,
            ysdgAllInventory: 0
          }
        ]
      } else {
        row.batchList.forEach(x => {
          this.selproductionDateBrokenTotal += parseInt(x.ysdgBrokenInventory)
          this.selproductionDateNormalTotal += parseInt(x.ysdgInventory)
        })
      }
      this.$set(this, 'productionDateRow', {...row})
      this.producedDateOpen = true
    },
    inputProductDateNormalAllNum (e) {
      this.selproductionDateNormalTotal = 0
      this.productionDateRow.batchList.forEach(x => {
        this.selproductionDateNormalTotal += parseInt(x.ysdgInventory || 0)
      })
    },
    inputProductDateBrokenAllNum (e) {
      this.selproductionDateBrokenTotal = 0
      this.productionDateRow.batchList.forEach(x => {
        this.selproductionDateBrokenTotal += parseInt(x.ysdgBrokenInventory || 0)
      })
    },
    submitProductionDateOpen () {
      console.log(this.productionDateRow)
      if (this.productionDateRow.batchList.some(x => x.ysdgProductionTime === '')) {
        this.$message({
          message: '请选择生产日期',
          type: 'warning'
        })
        return
      }
      selDateIndex = 0
      this.coverVerifySelDate(this.productionDateRow.batchList)
    },
    coverVerifySelDate (D) {
      if (parseInt(D[selDateIndex].ysdgBrokenInventory || 0) + parseInt(D[selDateIndex].ysdgInventory || 0) === 0) {
        this.$message({
          message: '正常品 + 破损品的数量不能为0，请填写数量',
          type: 'warning'
        })
        return
      }
      if (parseInt(D[selDateIndex].ysdgBrokenInventory || 0) > D[selDateIndex].ysdgAllBrokenInventory) {
        this.$message({
          message: '破损品的数量不能大于可上架破损品的数量，请重新填写数量',
          type: 'warning'
        })
        return
      }
      if (parseInt(D[selDateIndex].ysdgInventory || 0) > D[selDateIndex].ysdgAllInventory) {
        this.$message({
          message: '正常品的数量不能大于可上架正常品的数量，请重新填写数量',
          type: 'warning'
        })
        return
      }
      if ((selDateIndex + 1) < D.length) {
        selDateIndex++
        this.coverVerifySelDate(D)
      } else {
        let brokenAllNum = 0
        let allNum = 0
        D.forEach(x => {
          brokenAllNum += parseInt(x.ysdgBrokenInventory || 0)
          allNum += parseInt(x.ysdgInventory || 0)
        })
        this.productionDateRow.brokenAllNum = brokenAllNum
        this.productionDateRow.allNum = allNum
        this.selProductionsList[this.productionDateIndex] = this.productionDateRow
        this.$set(this, 'selProductionsList', [...this.selProductionsList])
        this.producedDateOpen = false
        this.productionDateIndex = 0
        this.productionDateRow = null
      }
    },
    cancleProductionDateOpen () {
      this.producedDateOpen = false
      this.productionDateIndex = 0
      this.productionDateRow = null
    },
    handleAddDate (idx) {
      console.log(idx)
      let obj = {
        ytgbId: '', // 批次id
        ysdgProductionTime: '', // 生产日期
        ysdgInventory: 0, // 批次正常品
        ysdgBrokenInventory: 0, // 批次破损品
        validUntil: '',
        ysdgAllBrokenInventory: 0,
        ysdgAllInventory: 0
      }
      this.productionDateRow.batchList.push(obj)
      // this.$set(this, 'productionDateRow', {...this.productionDateList})
    },
    handleDelDate (cidx) {
      let that = this
      that.productionDateRow.batchList.splice(cidx, 1)
      let selDateList = that.productionDateRow.batchList.map(x => x.ysdgProductionTime)
      this.productionDateRow.goodsBatch.forEach(x => {
        x.disabled = selDateList.some(ele => ele === x.ysdgProductionTime)
      })
    },
    selDate (e, cidx, expDays, oldTime) {
      this.productionDateRow.goodsBatch.forEach(x => {
        if (x.ysdgProductionTime === e) {
          this.productionDateRow.batchList[cidx].ysdgAllBrokenInventory = x.ysdgBrokenInventory
          this.productionDateRow.batchList[cidx].ysdgAllInventory = x.ysdgInventory
        }
      })
      let d2 = ''
      let isPastDue = false
      // eslint-disable-next-line eqeqeq
      if (e != '' && e != null) {
        console.log(6666)
        let d1 = new Date(e.replace('-', '/')).getTime()
        let expDate = 1000 * 60 * 60 * 24 * (expDays || 0)
        d2 = expDays ? parseTime((d1 + expDate), '{y}-{m}-{d}') : '-'
        isPastDue = expDays ? d1 + expDate < new Date().getTime() : false
      } else {
        d2 = '-'
      }
      this.productionDateRow.batchList[cidx].validUntil = d2
      this.productionDateRow.batchList[cidx].isPastDue = isPastDue
      let selDateList = this.productionDateRow.batchList.map(x => x.ysdgProductionTime)
      this.productionDateRow.goodsBatch.forEach(x => {
        x.disabled = selDateList.some(ele => ele === x.ysdgProductionTime)
      })
    },
    // 删除
    handleDel (idx) {
      this.selProductionsList.splice(idx, 1)
    },
    // 设置选中的方法
    setSelectRow (table, list, selections, idKey) {
      let selectAllIds = []
      this[selections].forEach((row) => {
        selectAllIds.push(row[idKey])
      })
      this.$refs[table].clearSelection()
      for (let i = 0; i < list.length; i++) {
        if (selectAllIds.indexOf(list[i][idKey]) >= 0) {
          this.$refs[table].toggleRowSelection(list[i], true)
        }
      }
    },
    // 记忆选择核心方法
    changePageCoreRecordData (idKey, multipleSelection, multipleSelectionAll) {
      // idKey 标识当前行的唯一键的名称
      // 标识当前行的唯一键的名称
      let that = this
      // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
      if (this[multipleSelectionAll].length <= 0) {
        this[multipleSelectionAll] = this[multipleSelection]
        return
      }
      // 总选择里面的key集合
      let selectAllIds = []
      this[multipleSelectionAll].forEach((row) => {
        selectAllIds.push(row[idKey])
      })
      let selectIds = []
      // 获取当前页选中的id
      this[multipleSelection].forEach((row) => {
        selectIds.push(row[idKey])
        // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
        if (selectAllIds.indexOf(row[idKey]) < 0) {
          that[multipleSelectionAll].push(row)
        }
      })
      let noSelectIds = []
      // 得到当前页没有选中的id
      this.productList.forEach((row) => {
        if (selectIds.indexOf(row[idKey]) < 0) {
          noSelectIds.push(row[idKey])
        }
      })
      noSelectIds.forEach((id) => {
        if (selectAllIds.indexOf(id) >= 0) {
          for (let i = 0; i < that[multipleSelectionAll].length; i++) {
            if (that[multipleSelectionAll][i][idKey] === id) {
              // 如果总选择中有未被选中的，那么就删除这条
              that[multipleSelectionAll].splice(i, 1)
              break
            }
          }
        }
      })
    },
    getCheck (code) {
      let list = new Promise((resolve, reject) => {
        _self.$store.dispatch(GETHECKED, {warehouseCode: code}).then(res => {
          let data = res.obj
          data.forEach(item => {
            if (item.yocOpenType === 0) {
              _self.isMdOpen = item.yocType
            }
          })
        })
      })
      console.log(list)
    }
  }
}
</script>
<style>
.el-table .cell{
  white-space: pre-line;
}
.el-table.addPutawayList .cell .num-input.el-input {
  width: 60px !important;
}
.page-content-table .scrollbar-wrapper{
  overflow-x: hidden !important;
  margin-bottom: 0 !important;
}
</style>
<style scope>
.page-content{
  position: fixed;
  top: 131px;
  left: 250px;
  bottom: 0;
  right: 0;
  padding: 8px;
  box-sizing: border-box;
  overflow: auto;
}
.box-card{
  width: 100%;
  background: #fff;
  padding: 12px 20px;
  font-size: 14px;
  box-sizing: border-box;
}
.box-card-head{
  color: #555;
  font-weight: 600;
  margin-bottom: 12px;
}
.head-content{
  box-sizing: border-box;
  padding-left: 20px;
  padding-bottom: 15px;
}
.body{
  margin-top: 8px;
  height: calc(100% - 114px);
}
/* 选择生产日期 */
.page-content-table{

  width: 100%;
  height: calc(100% - 93px);
}
.page-content-head{
  /* background: #f2f2f2; */
  /* height: 45px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #EBEEF5;
  color: #909399;
  font-weight: 600;
  box-sizing: border-box;
  font-size: 14px;
  width: 100%;
}
.page-content-body{
  color: #606266;
  box-sizing: border-box;
  /* border-bottom: 1px solid #EBEEF5; */
  font-size: 14px;
  height: calc(100% - 70px);
  width: 100%;
}
.page-content-body-list{
  width: 100%;
}
.page-content-body-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-left: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
  border-bottom: 1px solid #EBEEF5;
  box-sizing: border-box;
}
/* .page-content-body-item:last-child{
  border-bottom: 0 !important;
} */
.table-td{
  padding: 12px 10px;
  /* height: 70px; */
  /* box-sizing: border-box; */
  text-overflow: ellipsis;
  vertical-align: middle;
  text-align: center;
  display: table-cell;
  line-height: 46px;
  height: 46px;
  border-right: 1px solid #EBEEF5;
  /* white-space: pre; */
}
.table-td:last-child {
  border-right: none;
}
.vertical1 {
  width: 45px;
}
.vertical2 {
  width: calc(100% - 917px);
  min-width: 100px;
}
.vertical3 {
  display: flex;
  width: 230px;
}
.vertical4 {
  width: 100px;
}
.vertical5 {
  line-height: 23px;
  width: 120px;
}
.vertical6 {
  line-height: 23px;
  width: 120px;
}
.vertical7 {
  line-height: 23px;
  width: 160px;
}
.vertical8 {
  line-height: 23px;
  width: 160px;
}
.page-content-body .vertical7, .page-content-body .vertical8{
  line-height: 46px;
}
.date-select.el-date-editor.el-input{
  width: 140px !important;
}
.num-input.el-input{
  width: 100px !important;
}
</style>



// WEBPACK FOOTER //
// src/page/rollsHomework/putawayList/addPutawayList.vue